import React from 'react';
import { IFormSingleFieldParams, TInputField } from '../../types';

const CompanyEmployeesNumberSelect = ({
  meta,
  className,
  label,
  id,
  initValue,
  ...rest
}: TInputField & IFormSingleFieldParams) => {
  return (
    <div className={className}>
      <label htmlFor={id} className="select-label">
        {label}
      </label>
      <select id={id} defaultValue="label" {...rest}>
        <option value="label" disabled>
          {label}
        </option>
        <option value={'1-5'}>1-5</option>
        <option value={'6-20'}>6-20</option>
        <option value={'21-100'}>21-100</option>
        <option value={'101+'}>101+</option>
      </select>
      {meta && meta.error ? (
        <div className="helper-text" id={`${id}-helper-text`}>
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};

export default CompanyEmployeesNumberSelect;
